// Resources - e-SurveyPlan

<template>
<section class="lms3120-container">

  <div class="lms3120 white border-main shadow-dark">

    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="/resources">Resources</sym-link></li>
      <li><span aria-current="page">e-SurveyPlan</span></li>
    </Ul>

    <div class="p-2 lams curved border-lightgray mb-4">
      <h5 class="serif mb-0"><i class="fa fa-codepen ml-1 mr-2"></i>e-SurveyPlan</h5>
    </div>

    <div class="resources">

      <sym-card class="aliceblue lg-2 shadow-light" bodyClass="whitesmoke">
          <img src="img/resources-2.jpg" class="w-100">

          <a class="button success sm-1 warning darken-3 mb-4 lg-1 w-100 p-2" :href="surveyItems.filePath" download><i class="fa fa-download "></i><span class="button-caption ml-2">Download latest version ( {{ surveyItems.version }} )</span></a>
          
          <div v-show="surveyItems.resourceDetails">
            <p class="bold lg-3">What's New</p>
            <p class="px-4 text-justify" v-html="surveyItems.resourceDetails"></p>
          </div>
      </sym-card>

      <!-- <sym-card class="aliceblue lg-2 shadow-light" bodyClass="whitesmoke" v-for="(item, index) in surveyItems" :key="index">
          <img src="img/resources-2.jpg" class="w-100">
          <a class="button success sm-1 warning" :href="item.filePath" download><i class="fa fa-download"></i><span class="button-caption ml-2">Download latest version ( {{ item.version }} )</span></a>
      </sym-card> -->
      
<!-- 
      <sym-card class="aliceblue lg-2 shadow-light" bodyClass="whitesmoke">
        <img src="img/resources-2.jpg" class="w-100">
        <a href="./res/esurveyplan/e-SurveyPlan 2.4.zip" class="button warning darken-3 lg-1 w-100 p-2 text-center mb-4 shadow-dark"><i class="fa fa-download fa-lg mr-2"></i> Download latest version (v2.4)</a>

        <p class="bold lg-3">What's New</p>

        <ol class="px-4">
          <li>Fix and prevent application from hanging when GE performs multiple/continuous downloads of survey records.</li>
          <li>Added clear transaction list in GE transaction console.</li>
          <li>Includes resubmission of DLSD, survey plan and supporting documents.</li>
          <li>Added survey number, date approved and date rejected in routing details.</li>
          <li>Improve and fix error when submitting DLSD through online. It can now accept .tif file format for survey plan uploading.</li>
          <li>Improve performance in opening and saving complex subdivision with 2000 lots and above.</li>
          <li>Added downloading feature of survey plan and supporting documents. GE must have enough credit to be able to download files.</li>
          <li>Fix and rerouted updates to LMB server. All updates will be downloaded from LMB server.</li>
          <li>Improve performance when refreshing map.</li>
          <li>Added spatial and mathematical verification of resultant lots against block lots.</li>
          <li>Increase maximum characters allowed for survey name, claimant and etc.</li>
          <li>Added records count for each map layer.</li>
        </ol>
      </sym-card> -->

      <sym-card class="lams-light lg-2 shadow-light" headerClass="bold">
        <div slot="header">Lookup Files <br><small>{{ lookupFiles.releaseDate }}</small> </div>

          <ul class="lg-3" >
            <li class="list-item" v-for="(item, index) in lookupFiles" :key="index">
              <a :href="item.filePath"  class="serif">{{ item.resourceName }}</a>
            </li>
          </ul>

        <!-- <ul class="lg-3">
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">NCR</a>
          </li>
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">CAR</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles 000I.zip" class="serif">Region I</a>
          </li>
          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles 00II.zip" class="serif">Region II</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region III</a>
          </li>
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region IV-A</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region IV-B</a>
          </li>
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region V</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles 00VI.zip" class="serif">Region VI</a>
          </li>
          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles 0007.zip" class="serif">Region VII</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region VIII</a>
          </li>
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region IX</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region X</a>
          </li>
          <li class="list-item">
            <a href="javascript:void(0)" class="serif disabled no-pointer-events">Region XI</a>
          </li>

          <li class="list-item-separator">
          </li>

          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles 0012.zip" class="serif">Region XII</a>
          </li>
          <li class="list-item">
            <a href="./res/esurveyplan/LookupFiles/LookupFiles XIII.zip" class="serif">Region XIII</a>
          </li>
        </ul> -->

      </sym-card>

    </div>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-2 mb-2" @click="goBack()"><i class="fa fa-arrow-left mr-2"></i> Back</button>

  </div>

</section>
</template>

<script>
import SymCard from '../../comp/SymCard.vue';

import {
  get
} from '../../js/http';


import
  PageBase
from '../PageBase.vue';

export default {
  components: { SymCard },
  extends: PageBase,
  name: 'lms3120',


  data () {
    return {
      packages: [],
      surveyItems: [],
      previousItems: [],
      lookupFiles: [],
      isLoaded: false
    }
  },



  methods: {

    loadData () {
      const
        me = this,
        wait = me.wait();

      me.isLoaded = false;
      me.getPackages()
        .then ( items => {
          me.stopWait(wait);
          if (items && items.length) {
            me.packages = items.filter( o => o.sectionId === 5); 
            me.lookupFiles = items.filter( o => o.sectionId ===6);
            me.surveyItems = me.packages[0];
          } 
          me.isLoaded = true;
        })
        .catch( fault => {
          me.stopWait(wait);
          me.showFault(fault);
        });

    },   
  
    // API calls

    getPackages () {
      return get('api/packages');
    },

  },
  

  mounted () {
    const me = this;

    me.loadData();

  },

  
}



</script>

<style scoped>

.lms3120-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3120 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: .375rem;
}

.resources {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  column-gap: 1.5rem;
}

.list-item > a {
  display: block;
}

.list-item:hover {
  background: aliceblue;
}

@media (max-width: 1024px) {
  .lms3120 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 960px) {
  .lms3120-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms3120 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }
}

@media (max-width: 880px) {
  .lms3110 {
    padding: .5rem;
  }

  .resources {
    grid-template-columns: 1fr;
    row-gap: .25rem;
    column-gap: .25rem;
  }

  .card >>> .card-body {
    padding: .5rem;
  }

}

</style>